import {Auth} from '@aws-amplify/auth';
import {CommonModule} from '@angular/common';
import {Component,OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {EventSurveyApiService} from './event-survey-api.service';

@Component({selector:'app-event-survey-participant',standalone:true,imports:[CommonModule,FormsModule],
  templateUrl:'./event-survey-participant.component.html',styleUrl:'./event-survey.css'})
export class EventSurveyParticipantComponent implements OnInit {
  token='';form:any;answers:Record<string,any>={};name='';error='';loading=true;busy=false;complete=false;
  sessionId='';
  get sessionReady(){const sessions=this.form?.openingSessions||[];return !sessions.length||sessions.some((s:any)=>s.id===this.sessionId&&s.isOpen);}
  responseToken='';invitationToken='';revision=0;canRespond=false;
  constructor(private route:ActivatedRoute,private api:EventSurveyApiService){}
  async ngOnInit(){
    this.token=String(this.route.snapshot.paramMap.get('token')||'');
    try{
      this.form=await this.api.public(this.token,'form');
      if(this.form.openingSessions?.length===1)this.sessionId=this.form.openingSessions[0].id;
      const subject=this.form.targetSource==='attendance'?(history.state?.registrationToken?history.state.participantKey:(await Auth.currentAuthenticatedUser()).username):'shared';
      const storageKey='nest-event-survey-response:'+this.token+':'+subject;
      // Keep attendance-linked answers available when the participant returns from their own confirmation screen.
      // Standalone anonymous answers remain tab-scoped because there is no participant identity to separate users.
      if(this.form.targetSource==='attendance')try{this.responseToken=localStorage.getItem(storageKey)||'';}catch{}
      if(!this.responseToken)try{this.responseToken=sessionStorage.getItem(storageKey)||'';}catch{}
      if(this.responseToken){
        try{const saved=await this.api.public(this.token,'answer',{responseToken:this.responseToken});this.answers=saved.answers;this.revision=saved.revision;this.complete=true;this.canRespond=true;}catch(e:any){
          if(this.code(e)!=='answer_not_found')throw e;
          this.responseToken='';
          try{sessionStorage.removeItem(storageKey);localStorage.removeItem(storageKey);}catch{}
        }
      }
      if(!this.responseToken){
        this.responseToken=crypto.randomUUID();
        try{sessionStorage.setItem(storageKey,this.responseToken);}catch{}
        if(this.form.targetSource==='attendance')try{localStorage.setItem(storageKey,this.responseToken);}catch{}
      }
      if(this.form.targetSource==='attendance'&&!this.revision){
        const state=history.state;
        const invitation=state?.registrationToken
          ? await this.api.public(this.token,'invite',{participantKey:state.participantKey,registrationToken:state.registrationToken})
          : await this.api.public(this.token,'invite_staff',{},true);
        this.invitationToken=invitation.invitationToken;
      }
      this.canRespond=true;
    }catch(e:any){this.error=this.code(e)==='already_answered'
      ?'回答済みです。このブラウザには回答を開くための情報が残っていません。'
      :e?.error?.message||e?.message||'出欠の申込確認画面、またはログイン後の出欠画面からアンケートを開いてください。';}
    finally{this.loading=false;}
  }
  private code(e:any){return e?.error?.data?.code||e?.data?.code;}
  toggle(id:string,value:string,checked:boolean){const selected=this.answers[id]||[];this.answers[id]=checked?[...new Set([...selected,value])]:selected.filter((x:string)=>x!==value);}
  async submit(){
    if(this.busy||!this.canRespond||(!this.revision&&!this.sessionReady))return;this.busy=true;this.error='';
    try{const result=await this.api.public(this.token,'submit',{sessionId:this.sessionId,responseToken:this.responseToken,invitationToken:this.invitationToken,definitionVersion:this.form.definitionVersion,answers:this.answers,name:this.name,expectedRevision:this.revision});this.revision=result.revision;this.complete=true;window.scrollTo({top:0,behavior:'smooth'});}
    catch(e:any){this.error=e?.error?.message||e?.message||'回答を送信できませんでした。再度お試しください。';}
    finally{this.busy=false;}
  }
}
